import {
  GET_DSP_USER_LIST,
  GET_TARIFF,
  GET_UNUSED_VOUCHER,
  GET_VOUCHER_MANAGEMENT,
  SAVE_INVOICE,
  GET_VOUCHER_SEARCH,
  CHECK_VOUCHER_INVOICE,
  GENERATE_DELIVERY_NOTES,
  GENERATE_INVOICE,
  CLEAR_DELIVERY_NOTES_PREVIEW
} from "../../admin-constants";
import CardInvoiceService from "../../../services/admin/cardinvoice.service";
import { showLoader, hideLoader } from "../../common/actions";
import { showModal } from "../../modal/actions";

export const getDspUserList = (data) => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.getDspUserList(data);
    if (resultData?.status) {
      dispatch({
        type: GET_DSP_USER_LIST,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const getTariff = () => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.getTariff();
    if (resultData?.status) {
      dispatch({
        type: GET_TARIFF,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const getUnusedVoucher = (data) => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.getUnusedVoucher(data);

   if (resultData?.status) {
    dispatch({
      type: GET_UNUSED_VOUCHER,
      payload: resultData?.data ? resultData.data : [],
    
    
    });
     }
  } catch (err) {
    console.log(err);
  }
};

export const geVoucherManagement = (data) => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.geVoucherManagement(data);
    if (resultData?.status) {
      dispatch({
        type: GET_VOUCHER_MANAGEMENT,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const saveInvoice = (data, resetPage) => async (dispatch) => {
  try {
    dispatch(showLoader());
    const resultData = await CardInvoiceService.saveInvoice(data);
    if (resultData?.status) {
             dispatch(showModal({
                  title: "Success",
                  message: "Updated successfully",
                  iconType: "success",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
      dispatch({
        type: SAVE_INVOICE,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
      resetPage()
    }else{
            dispatch(showModal({
                  title: "Failure",
                  message: "Something wrong while updating",
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }
  } catch (err) {
    console.log(err);
  }
  finally {
      dispatch(hideLoader());
    }
};

export const getVoucherSearch = (data) => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.getVoucherSearch(data);
    if (resultData?.status) {
      dispatch({
        type: GET_VOUCHER_SEARCH,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const checkVoucherInvoice = (data) => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.checkVoucherInvoice(data);

    dispatch({
      type: CHECK_VOUCHER_INVOICE,
      payload: resultData,
    });
  } catch (err) {
    console.log(err);
  }
};

export const generateDeliveryNotes = (data) => async (dispatch) => {
  try {
    const resultData = await CardInvoiceService.generateDeliveryNotes(data);
    dispatch({
      type: GENERATE_DELIVERY_NOTES,
      payload: resultData,
    });
  } catch (err) {
    console.log(err);
  }
};

export const clearDeliveryNotesPreview = () => ({
  type: CLEAR_DELIVERY_NOTES_PREVIEW,
});




